/* dde-ids-session.js — IDS-Punchout-Parameter fuer die Sitzung aufbewahren
 * (Serdar, 23.09.2026).
 *
 * Die Handwerker-Software schickt den Kaeufer mit einem vorbereiteten Warenkorb
 * in den Shop:  /cart/<id>:<menge>,…?storefront=true&hookurl=…&kommission=…
 * Shopify legt daraus einen neuen Warenkorb an, uebernimmt attributes[…] und
 * note in den Warenkorb (so kommt die Lieferadresse an) und haengt alle anderen
 * Parameter nur an die URL der ERSTEN Warenkorbseite:
 *   /cart?cart_link_id=…&hookurl=…&kommission=…
 * Wechselte der Kaeufer danach auf eine Produktseite oder meldete sich an, war
 * die hookurl weg — und damit "Warenkorb uebertragen".
 *
 * Diese Datei haelt die Parameter fest:
 *   * alle Query-Parameter der Einstiegs-URL (ausser Shopifys eigenen) und die
 *     Warenkorb-Attribute + note in dem Moment (der Warenkorb ist frisch aus dem
 *     Link gebaut, also sind das genau die aus IDS);
 *   * FEST 60 Minuten ab dem Einstieg — kein Verlaengern beim Weiterklicken,
 *     auch nicht durch Neuladen der Einstiegs-URL (siehe SEEN_KEY);
 *   * in sessionStorage (verschwindet mit dem Tab) UND im Cookie `dde_ids`
 *     (Max-Age 3600, volle Werte). Gueltig ist die Sitzung nur, wenn beides da
 *     ist und expiresAt nicht vorbei ist; sonst wird beides geloescht.
 *
 * Tabs: ein Cookie kann nicht "beim Schliessen des Tabs" verschwinden, deshalb
 * haengt die Sitzung am sessionStorage. Ein NEUER Tab (Strg+Klick oeffnet ohne
 * Opener, sessionStorage wird dann nicht kopiert) fragt ueber BroadcastChannel
 * nach, ob noch ein Tab dieser Sitzung offen ist: antwortet einer, uebernimmt
 * der neue Tab die Sitzung; antwortet keiner (alle Tabs geschlossen), wird das
 * Cookie geloescht.
 *
 * Laedt im <head> (layout/theme.liquid), synchron und vor cart-sap-reprice.js,
 * das ueber window.ddeIdsSession liest. Nur im Testshop-Theme.
 */
(function () {
  'use strict';

  var STORE_KEY = 'dde_ids_session';
  var SEEN_KEY = 'dde_ids_seen';        // schon erfasste Einstiegs-URLs (dieser Tab)
  var COOKIE = 'dde_ids';
  var TTL_MS = 60 * 60 * 1000;          // fest 60 Minuten
  var COOKIE_MAX = 3800;                // Bytes fuer den Cookie-Wert (Browser: ~4096 inkl. Name)
  var CHANNEL = 'dde-ids-session';

  // Shopify-eigene und Tracking-Parameter — die gehoeren nicht zur IDS-Sitzung.
  var IGNORE = {
    cart_link_id: 1, storefront: 1, _pos: 1, _sid: 1, _ss: 1, _psq: 1, _v: 1, _fd: 1,
    _ab: 1, pb: 1, preview_theme_id: 1, oseid: 1, srsltid: 1, fbclid: 1, gclid: 1,
    variant: 1, locale: 1, country: 1
  };
  var MAX_PARAMS = 40, MAX_VALUE = 2000;

  function now() { return Date.now(); }

  // ── Speicher ────────────────────────────────────────────────────────────────
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); return true; } catch (e) { return false; } }
  function ssDel(k) { try { sessionStorage.removeItem(k); } catch (e) { /* egal */ } }

  function readCookie() {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + COOKIE + '=([^;]*)'));
    if (!m) return null;
    try { return JSON.parse(decodeURIComponent(m[1])); } catch (e) { return null; }
  }
  function cookieAttrs(maxAge) {
    return '; Path=/; Max-Age=' + maxAge + '; SameSite=Lax' +
      (location.protocol === 'https:' ? '; Secure' : '');
  }
  function writeCookie(rec) {
    var left = Math.max(1, Math.floor((rec.expiresAt - now()) / 1000));
    // Volle Werte. Passt es nicht, faellt zuerst der Attribut-Schnappschuss weg
    // (die Attribute liegen ohnehin auch am Shopify-Warenkorb), dann note —
    // die Query-Parameter mit der hookurl bleiben immer drin.
    var variants = [rec,
      { id: rec.id, capturedAt: rec.capturedAt, expiresAt: rec.expiresAt, params: rec.params, note: rec.note, truncated: 'attributes' },
      { id: rec.id, capturedAt: rec.capturedAt, expiresAt: rec.expiresAt, params: rec.params, truncated: 'attributes,note' }];
    for (var i = 0; i < variants.length; i++) {
      var v = encodeURIComponent(JSON.stringify(variants[i]));
      if (v.length <= COOKIE_MAX) { document.cookie = COOKIE + '=' + v + cookieAttrs(left); return; }
    }
    // Selbst die Parameter allein sind zu gross: nur die Kennung, damit die
    // Sitzung (die in sessionStorage vollstaendig liegt) gueltig bleibt.
    document.cookie = COOKIE + '=' + encodeURIComponent(JSON.stringify(
      { id: rec.id, capturedAt: rec.capturedAt, expiresAt: rec.expiresAt, truncated: 'all' })) + cookieAttrs(left);
  }
  function deleteCookie() { document.cookie = COOKIE + '=' + cookieAttrs(0); }

  function readRecord() {
    var raw = ssGet(STORE_KEY);
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }
  function saveRecord(rec) {
    ssSet(STORE_KEY, JSON.stringify(rec));
    writeCookie(rec);
  }

  function clear(reason) {
    ssDel(STORE_KEY);
    deleteCookie();
    if (reason) console.info('[ids-session] beendet:', reason);
    try { document.dispatchEvent(new CustomEvent('dde:ids-session', { detail: { active: false, reason: reason || '' } })); } catch (e) { /* alt */ }
  }

  // ── Erfassen ────────────────────────────────────────────────────────────────
  function collectParams() {
    var out = {}, n = 0;
    new URLSearchParams(location.search).forEach(function (v, k) {
      if (IGNORE[k] || /^utm_/.test(k) || n >= MAX_PARAMS) return;
      if (out[k] != null) return;       // erster Wert gewinnt, wie URLSearchParams.get
      out[k] = String(v).slice(0, MAX_VALUE);
      n++;
    });
    return out;
  }

  function signature(params, linkId) {
    var keys = Object.keys(params).sort();
    return (linkId || '') + '|' + keys.map(function (k) { return k + '=' + params[k]; }).join('&');
  }
  function seenList() {
    try { return JSON.parse(ssGet(SEEN_KEY) || '[]'); } catch (e) { return []; }
  }

  // Einstieg aus IDS: eine hookurl in der URL, oder ein Warenkorb-Link
  // (cart_link_id) mit eigenen Parametern. Ein reiner Shopify-Warenkorb-Link ohne
  // weitere Parameter ist kein Punchout.
  function captureFromUrl() {
    var q = new URLSearchParams(location.search);
    var linkId = q.get('cart_link_id');
    var params = collectParams();
    if (!params.hookurl && !(linkId && Object.keys(params).length)) return null;

    // Dieselbe Einstiegs-URL nicht noch einmal erfassen: Neuladen der ersten
    // Warenkorbseite wuerde sonst die festen 60 Minuten neu starten — und eine
    // abgelaufene Sitzung wieder aufleben lassen.
    var sig = signature(params, linkId);
    var seen = seenList();
    if (seen.indexOf(sig) !== -1) return null;
    seen.push(sig);
    ssSet(SEEN_KEY, JSON.stringify(seen.slice(-10)));

    var t = now();
    var rec = {
      id: t.toString(36) + '-' + Math.random().toString(36).slice(2, 8),
      capturedAt: t,
      expiresAt: t + TTL_MS,
      source: location.pathname,
      cartLinkId: linkId || '',
      params: params,
      attributes: {},
      note: ''
    };
    // Ein neuer Link ersetzt die alte Sitzung komplett.
    saveRecord(rec);
    console.info('[ids-session] erfasst, gueltig bis', new Date(rec.expiresAt).toLocaleTimeString('de-DE'),
      Object.keys(params));

    // Warenkorb-Attribute + note aus dem Link dazulegen (asynchron — die
    // Query-Parameter sind schon gesichert, falls das hier scheitert).
    if (linkId) {
      fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var cur = readRecord();
          if (!cur || cur.id !== rec.id) return;   // inzwischen ersetzt/beendet
          cur.attributes = (cart && cart.attributes) || {};
          cur.note = (cart && cart.note) || '';
          saveRecord(cur);
          announce(cur);
        })
        .catch(function () { /* Attribute liegen trotzdem am Warenkorb */ });
    }
    return rec;
  }

  // ── Gueltigkeit ─────────────────────────────────────────────────────────────
  function validRecord() {
    var rec = readRecord();
    if (!rec) return null;
    if (!(rec.expiresAt > now())) { clear('60 Minuten abgelaufen'); return null; }
    // Cookies im Browser gesperrt: dann traegt sessionStorage allein die Sitzung.
    if (navigator.cookieEnabled === false) return rec;
    var c = readCookie();
    if (!c || c.id !== rec.id) { clear('Cookie fehlt oder gehoert zu einer anderen Sitzung'); return null; }
    return rec;
  }

  function announce(rec) {
    try { document.dispatchEvent(new CustomEvent('dde:ids-session', { detail: { active: !!rec, record: rec } })); } catch (e) { /* alt */ }
  }

  // ── Tabs ────────────────────────────────────────────────────────────────────
  var bc = null;
  try { bc = new BroadcastChannel(CHANNEL); } catch (e) { bc = null; }
  if (bc) {
    bc.onmessage = function (ev) {
      var m = ev.data || {};
      if (m.type === 'ping') {
        var rec = validRecord();
        if (rec && rec.id === m.id) bc.postMessage({ type: 'pong', id: rec.id, record: rec });
      } else if (m.type === 'pong' && m.record && !readRecord()) {
        var c = readCookie();
        if (c && c.id === m.id && m.record.expiresAt > now()) {
          ssSet(STORE_KEY, JSON.stringify(m.record));
          announce(m.record);
        }
      } else if (m.type === 'clear' && m.id) {
        var mine = readRecord();
        if (mine && mine.id === m.id) { ssDel(STORE_KEY); announce(null); }
      }
    };
  }

  // Neuer Tab ohne eigene Sitzung, aber mit Cookie: lebt noch ein Tab?
  function adoptOrExpireCookie() {
    var c = readCookie();
    if (!c || !c.id) return;
    if (!(c.expiresAt > now())) { deleteCookie(); return; }
    if (!bc) { return; }   // ohne BroadcastChannel: das Cookie laeuft von selbst ab
    bc.postMessage({ type: 'ping', id: c.id });
    setTimeout(function () {
      if (!readRecord() && readCookie() && readCookie().id === c.id) {
        deleteCookie();
        console.info('[ids-session] kein Tab dieser Sitzung mehr offen — Cookie geloescht');
      }
    }, 600);
  }

  var captured = captureFromUrl();
  if (!captured) {
    if (readRecord()) validRecord();
    else adoptOrExpireCookie();
  }

  // ── Oeffentliche Schnittstelle ──────────────────────────────────────────────
  window.ddeIdsSession = {
    // Ganzer Datensatz, oder null wenn keine (gueltige) Sitzung.
    record: function () { return validRecord(); },
    active: function () { return !!validRecord(); },
    // Ein Parameter aus der Einstiegs-URL (hookurl, kommission, …).
    get: function (name) {
      var rec = validRecord();
      return rec && rec.params && rec.params[name] != null ? rec.params[name] : null;
    },
    // Ein Warenkorb-Attribut, wie es mit dem Link kam.
    attribute: function (name) {
      var rec = validRecord();
      return rec && rec.attributes && rec.attributes[name] != null ? rec.attributes[name] : null;
    },
    expiresAt: function () { var rec = validRecord(); return rec ? rec.expiresAt : null; },
    clear: function (reason) {
      var rec = readRecord();
      clear(reason || 'beendet');
      if (bc && rec) bc.postMessage({ type: 'clear', id: rec.id });
    }
  };
})();
